import { type AxiosResponse } from 'axios';
import { BASE_URL } from '@avanta/shared/constants/common';
import { type Center } from '@avanta/shared/types/centers';
import { getAnonymousTokenCookie } from '@avanta/shared/utils/storage';
import { service } from '../api';
import { getAnonymousToken } from '../auth';

const CENTERS_URL = `${BASE_URL}centers`;
export interface CenterServiceTypes {
  getCentersByEnterprise: (enterpriseId: string) => Promise<AxiosResponse<Center[]>>;
  getCenter: (centerId: string) => Promise<AxiosResponse<Center>>;
}

export const CenterService: CenterServiceTypes = {
  getCentersByEnterprise: async enterpriseId => {
    const anonymousToken =
      getAnonymousTokenCookie() || (await getAnonymousToken())?.data.access_token;
    return service.get(`${CENTERS_URL}`, {
      headers: { Authorization: `Bearer ${anonymousToken}` },
      params: {
        enterpriseId,
      },
    });
  },
  getCenter: async centerId => service.get(`${CENTERS_URL}/${centerId}`),
};
